module.exports = [
  {
    en: 'General',
    vocabularies: [
      {
        en: 'Yes',
        de: 'Ja',
      },
      {
        en: 'No',
        de: 'Nein',
      },
      {
        en: 'perhaps',
        de: 'vielleicht',
      },
      {
        en: 'please',
        de: 'Bitte',
      },
      {
        en: 'thank you',
        de: 'Danke',
      },
      {
        en: 'Excuse me',
        de: 'Entschuldigung',
      },
      {
        en: 'all right',
        de: 'Alles klar',
      },
      {
        en: 'I (do not) understand',
        de: 'Ich verstehe (nicht)',
      },
      {
        en: 'Do you speak German?',
        de: 'Sprechen Sie Deutsch?',
      },
      {
        en: 'I do not speak German',
        de: 'Ich spreche kein Deutsch',
      },
      {
        en: 'Help!',
        de: 'Hilfe!',
      },
      {
        en: 'A bit slower please',
        de: 'Ein bisschen langsamer bitte',
      },
      {
        en: 'Bless you!',
        de: 'Gesundheit!',
      },
      {
        en: 'Cheers!',
        de: 'Prost!',
      },
      {
        en: 'Where',
        de: 'Wo',
      },
      {
        en: 'When',
        de: 'Wann',
      },
      {
        en: 'Who',
        de: 'Wer',
      },
      {
        en: 'Why',
        de: 'Warum',
      },
    ],
  },
  {
    en: 'Introduction',
    vocabularies: [
      {
        en: 'Surname',
        de: 'Name',
      },
      {
        en: "What's your name?",
        de: 'Wie heißen Sie?',
      },
      {
        en: 'My name is…',
        de: 'Ich heiße…',
      },
      {
        en: 'I am…',
        de: 'Ich bin…',
      },
      {
        en: "It's nice to meet you",
        de: 'Es ist schön Sie kennenzulernen',
      },
      {
        en: 'I am X years old',
        de: 'Ich bin X Jahre alt',
      },
      {
        en: "I'm from…",
        de: 'Ich komme aus…',
      },
      {
        en: 'How old are they?',
        de: 'Wie alt sind Sie?',
      },
      {
        en: 'Where do they work?',
        de: 'Wo arbeiten Sie?',
      },
      {
        en: 'Where are you from?',
        de: 'Wo kommen Sie her?',
      },
      {
        en: 'What brings you here?',
        de: 'Was bringt Sie hierher?',
      },
      {
        en: 'How was your trip?',
        de: 'Wie war Ihre Reise?',
      },
      {
        en: 'Do you have a good time?',
        de: 'Haben Sie eine gute Zeit?',
      },
      {
        en: 'What do you think of …?',
        de: 'Was halten Sie von …?',
      },
      {
        en: 'My friends call me …',
        de: 'Meine Freunde nennen mich …',
      },
      {
        en: 'Do we know each other?',
        de: 'Kennen wir uns?',
      },
      {
        en: 'This is (name)',
        de: 'Dies ist (Name)',
      },
      {
        en: 'How was your weekend?',
        de: 'Wie war Ihr Wochenende?',
      },
    ],
  },
  {
    en: 'Welcome / Send-off',
    vocabularies: [
      {
        en: 'Hi',
        de: 'Hey',
      },
      {
        en: 'Good Morning',
        de: 'Guten Morgen',
      },
      {
        en: 'Good day',
        de: 'Guten Tag',
      },
      {
        en: 'Good evening',
        de: 'Guten Abend',
      },
      {
        en: 'Good night',
        de: 'Gute Nacht',
      },
      {
        en: 'Bye',
        de: 'Tschüss',
      },
      {
        en: 'Goodbye',
        de: 'Auf Wiedersehen',
      },
      {
        en: 'How are you?',
        de: 'Wie geht es Ihnen?',
      },
      {
        en: 'Good',
        de: 'Gut',
      },
      {
        en: 'Bad',
        de: 'Schlecht',
      },
      {
        en: 'Hey, Hello',
        de: 'Hey / Hallo',
      },
      {
        en: 'How are you?',
        de: "Wie geht's?",
      },
      {
        en: "What's going on?",
        de: 'Was gibt’s neues?',
      },
      {
        en: 'Nice to see you',
        de: 'Schön Sie zu sehen.',
      },
      {
        en: 'Nice to meet you',
        de: 'Nett Sie kennenzulernen',
      },
      {
        en: 'Take care',
        de: "Mach's gut",
      },
      {
        en: 'Long time no see',
        de: 'Lange nicht gesehen',
      },
      {
        en: "What's up?",
        de: "Wie steht's?",
      },
    ],
  },
  {
    en: 'travel',
    vocabularies: [
      {
        en: 'I would like…',
        de: 'Ich möchte gerne…',
      },
      {
        en: 'Where are the toilets?',
        de: 'Wo sind die Toilleten?',
      },
      {
        en: 'What time is it?',
        de: 'Wie spät ist es?',
      },
      {
        en: 'I stay at ...',
        de: 'Ich übernachte bei…',
      },
      {
        en: 'I visit family',
        de: 'Ich besuche Familie',
      },
      {
        en: 'I am here for X days',
        de: 'Ich bin hier für X Tage',
      },
      {
        en: 'Do you have a card?',
        de: 'Haben Sie eine Karte?',
      },
      {
        en: 'passport',
        de: 'Reisepass',
      },
      {
        en: 'Airport',
        de: 'Flughafen',
      },
      {
        en: 'port',
        de: 'Hafen',
      },
      {
        en: 'safety',
        de: 'Sicherheit',
      },
      {
        en: 'plane',
        de: 'Flugzeug',
      },
      {
        en: 'train',
        de: 'Zug',
      },
      {
        en: 'ship',
        de: 'Schiff',
      },
      {
        en: 'bicycle',
        de: 'Fahrrad',
      },
      {
        en: 'motorcycle',
        de: 'Motorrad',
      },
      {
        en: 'bus',
        de: 'Bus',
      },
      {
        en: 'to fly',
        de: 'fliegen',
      },
      {
        en: 'drive',
        de: 'fahren',
      },
      {
        en: 'sailing',
        de: 'segeln',
      },
    ],
  },
  {
    en: 'Directions',
    vocabularies: [
      {
        en: 'Left',
        de: 'links',
      },
      {
        en: 'right',
        de: 'rechts',
      },
      {
        en: 'here',
        de: 'hier',
      },
      {
        en: 'there',
        de: 'dort',
      },
      {
        en: 'back',
        de: 'zurück',
      },
      {
        en: 'high',
        de: 'hoch',
      },
      {
        en: 'down',
        de: 'runter',
      },
      {
        en: 'straight',
        de: 'geradeaus',
      },
      {
        en: 'place',
        de: 'Ort',
      },
      {
        en: 'Where is…?',
        de: 'Wo ist…?',
      },
      {
        en: 'How do I get to…?',
        de: 'Wie komme ich nach…?',
      },
      {
        en: 'Seeking ... street.',
        de: 'Ich suche ... Straße.',
      },
      {
        en: 'around the corner',
        de: 'um die Ecke',
      },
      {
        en: 'far',
        de: 'weit',
      },
      {
        en: 'near',
        de: 'in der Nähe von',
      },
      {
        en: 'across from',
        de: 'gegenüber von',
      },
      {
        en: 'follow me',
        de: 'Folgen Sie mir',
      },
      {
        en: 'next X',
        de: 'neben X',
      },
      {
        en: 'pass',
        de: 'vorbeigehen',
      },
      {
        en: 'between',
        de: 'zwischen',
      },
    ],
  },
  {
    en: 'Times / data',
    vocabularies: [
      {
        en: 'now',
        de: 'jetzt',
      },
      {
        en: 'today',
        de: 'heute',
      },
      {
        en: 'morning',
        de: 'morgen',
      },
      {
        en: 'yesterday',
        de: 'gestern',
      },
      {
        en: 'second',
        de: 'Sekunde',
      },
      {
        en: 'minute',
        de: 'Minute',
      },
      {
        en: 'hour',
        de: 'Stunde',
      },
      {
        en: 'Day',
        de: 'Tag',
      },
      {
        en: 'week',
        de: 'Woche',
      },
      {
        en: 'month',
        de: 'Monat',
      },
      {
        en: 'year',
        de: 'Jahr',
      },
      {
        en: 'early',
        de: 'früh',
      },
      {
        en: 'late',
        de: 'spät',
      },
      {
        en: 'Monday',
        de: 'Montag',
      },
      {
        en: 'Tuesday',
        de: 'Dienstag',
      },
      {
        en: 'Wednesday',
        de: 'Mittwoch',
      },
      {
        en: 'Thursday',
        de: 'Donnerstag',
      },
      {
        en: 'Friday',
        de: 'Freitag',
      },
      {
        en: 'Saturday',
        de: 'Samstag',
      },
      {
        en: 'Sunday',
        de: 'Sonntag',
      },
      {
        en: 'spring',
        de: 'Frühling',
      },
      {
        en: 'summer',
        de: 'Sommer',
      },
      {
        en: 'autumn',
        de: 'Herbst',
      },
      {
        en: 'winter',
        de: 'Winter',
      },
      {
        en: 'January',
        de: 'Januar',
      },
      {
        en: 'February',
        de: 'Februar',
      },
      {
        en: 'March',
        de: 'März',
      },
      {
        en: 'April',
        de: 'April',
      },
      {
        en: 'May',
        de: 'Mai',
      },
      {
        en: 'June',
        de: 'Juni',
      },
      {
        en: 'July',
        de: 'Juli',
      },
      {
        en: 'August',
        de: 'August',
      },
      {
        en: 'September',
        de: 'September',
      },
      {
        en: 'October',
        de: 'Oktober',
      },
      {
        en: 'November',
        de: 'November',
      },
      {
        en: 'December',
        de: 'Dezember',
      },
      {
        en: 'time of day',
        de: 'Uhrzeit',
      },
      {
        en: 'decade',
        de: 'Jahrzehnt',
      },
      {
        en: 'century',
        de: 'Jahrhundert',
      },
    ],
  },
  {
    en: 'places',
    vocabularies: [
      {
        en: 'Supermarket',
        de: 'Supermarkt',
      },
      {
        en: 'hospital',
        de: 'Krankenhaus',
      },
      {
        en: 'Bank',
        de: 'Bank',
      },
      {
        en: 'hotel',
        de: 'Hotel',
      },
      {
        en: 'bar',
        de: 'Bar',
      },
      {
        en: 'pharmacy',
        de: 'Apotheke',
      },
      {
        en: 'Beach',
        de: 'Strand',
      },
      {
        en: 'restaurant',
        de: 'Restaurant',
      },
      {
        en: 'bakery',
        de: 'Bäckerei',
      },
      {
        en: 'Bus stop',
        de: 'Bushaltestelle',
      },
      {
        en: 'church',
        de: 'Kirche',
      },
      {
        en: 'movie theater',
        de: 'Kino',
      },
      {
        en: 'Gas station',
        de: 'Tankstelle',
      },
      {
        en: 'museum',
        de: 'Museum',
      },
      {
        en: 'Police station',
        de: 'Polizeistation',
      },
      {
        en: 'school',
        de: 'Schule',
      },
      {
        en: 'space',
        de: 'Platz',
      },
      {
        en: 'zoo',
        de: 'Zoo',
      },
    ],
  },
  {
    en: 'shopping',
    vocabularies: [
      {
        en: 'expensive',
        de: 'teuer',
      },
      {
        en: 'cheap',
        de: 'billig',
      },
      {
        en: 'free',
        de: 'kostenlos',
      },
      {
        en: 'How much is it?',
        de: 'Wie viel kostet das?',
      },
      {
        en: 'cashier',
        de: 'Kassierer',
      },
      {
        en: 'Trolley / Cart',
        de: 'Trolley / Warenkorb',
      },
      {
        en: 'bag',
        de: 'Tasche',
      },
      {
        en: 'guarantee',
        de: 'Garantie',
      },
      {
        en: 'refund policy',
        de: 'Rückgaberecht',
      },
      {
        en: 'debit card',
        de: 'Kundenkarte',
      },
      {
        en: 'VAT receipt',
        de: 'Mehrwertsteuer-Quittung',
      },
      {
        en: 'Discount',
        de: 'Rabatt',
      },
      {
        en: 'corridor',
        de: 'Gang',
      },
      {
        en: 'shelf',
        de: 'Regal',
      },
      {
        en: 'changing room',
        de: 'Umkleidekabine',
      },
      {
        en: 'delivery',
        de: 'Lieferung',
      },
      {
        en: 'Sale',
        de: 'Schlussverkauf',
      },
      {
        en: 'Excuse me, do you work here?',
        de: 'Entschuldigen Sie, arbeiten Sie hier?',
      },
    ],
  },
  {
    en: 'In the restaurant',
    vocabularies: [
      {
        en: 'A table for X people, please.',
        de: 'Einen Tisch für X Personen, bitte.',
      },
      {
        en: 'I would like to order.',
        de: 'Ich würde gerne bestellen.',
      },
      {
        en: 'Can I have the card?',
        de: 'Kann ich bitte die Karte haben?',
      },
      {
        en: 'The Bill please.',
        de: 'Die Rechnung bitte.',
      },
      {
        en: 'breakfast',
        de: 'Frühstück',
      },
      {
        en: 'dine',
        de: 'Mittagsessen',
      },
      {
        en: 'dinner',
        de: 'Abendessen',
      },
      {
        en: 'cutlery',
        de: 'Besteck',
      },
      {
        en: 'napkin',
        de: 'Serviette',
      },
      {
        en: 'brunch',
        de: 'Brunch',
      },
      {
        en: 'main course',
        de: 'Hauptgang',
      },
      {
        en: 'dessert',
        de: 'Dessert',
      },
      {
        en: 'tip',
        de: 'Trinkgeld',
      },
      {
        en: 'garnish',
        de: 'Beilage',
      },
      {
        en: 'beverages',
        de: 'Getränke',
      },
      {
        en: 'all you can eat',
        de: 'So viel du essen kannst',
      },
      {
        en: 'Happy Hour',
        de: 'Happy Hour',
      },
      {
        en: 'appetizer',
        de: 'Appetizer',
      },
    ],
  },
  {
    en: 'At the hotel',
    vocabularies: [
      {
        en: 'room',
        de: 'Zimmer',
      },
      {
        en: 'room service',
        de: 'Zimmerservice',
      },
      {
        en: 'bathroom',
        de: 'Badezimmer',
      },
      {
        en: 'bed',
        de: 'Bett',
      },
      {
        en: 'bedroom',
        de: 'Schlafzimmer',
      },
      {
        en: 'floor',
        de: 'Etage',
      },
      {
        en: 'elevator',
        de: 'Aufzug',
      },
      {
        en: 'reception',
        de: 'Rezeption',
      },
      {
        en: 'towel',
        de: 'Handtuch',
      },
      {
        en: 'Outbuildings',
        de: 'Nebenräume',
      },
      {
        en: 'baggage',
        de: 'Gepäck',
      },
      {
        en: 'page',
        de: 'Page',
      },
      {
        en: 'kitchenette',
        de: 'Kochnische',
      },
      {
        en: 'bed linen',
        de: 'Bettwäsche',
      },
      {
        en: 'valet',
        de: 'Kammerdiener',
      },
      {
        en: 'lobby',
        de: 'Lobby',
      },
      {
        en: 'deposit',
        de: 'Anzahlung',
      },
      {
        en: 'check in',
        de: 'Einchecken',
      },
      {
        en: 'check-Out',
        de: 'Auschecken',
      },
      {
        en: 'free',
        de: 'Gratis',
      },
    ],
  },
  {
    en: 'numbers',
    vocabularies: [
      {
        en: 'one',
        de: 'Eins',
      },
      {
        en: 'Two',
        de: 'Zwei',
      },
      {
        en: 'Three',
        de: 'Drei',
      },
      {
        en: 'Four',
        de: 'Vier',
      },
      {
        en: 'five',
        de: 'Fünf',
      },
      {
        en: 'six',
        de: 'Sechs',
      },
      {
        en: 'seven',
        de: 'Sieben',
      },
      {
        en: 'eight',
        de: 'Acht',
      },
      {
        en: 'nine',
        de: 'Neun',
      },
      {
        en: 'ten',
        de: 'Zehn',
      },
      {
        en: 'Eleven',
        de: 'Elf',
      },
      {
        en: 'Twelve',
        de: 'Zwölf',
      },
      {
        en: 'Thirteen',
        de: 'Dreizehn',
      },
      {
        en: 'fourteen',
        de: 'Vierzehn',
      },
      {
        en: 'Fifteen',
        de: 'Fünfzehn',
      },
      {
        en: 'Sixteen',
        de: 'Sechszehn',
      },
      {
        en: 'Seventeen',
        de: 'Siebzehn',
      },
      {
        en: 'Eighteen',
        de: 'Achtzehn',
      },
      {
        en: 'Nineteen',
        de: 'Neunzehn',
      },
      {
        en: 'Twenty',
        de: 'Zwanzig',
      },
      {
        en: 'Thirty',
        de: 'Dreißig',
      },
      {
        en: 'Fourty',
        de: 'Vierzig',
      },
      {
        en: 'Fifty',
        de: 'Fünfzig',
      },
      {
        en: 'sixty',
        de: 'Sechszig',
      },
      {
        en: 'Siebzieg',
        de: 'Siebzieg',
      },
      {
        en: 'eighty',
        de: 'Achzig',
      },
      {
        en: 'Ninety',
        de: 'Neunzig',
      },
      {
        en: 'Hundred',
        de: 'Hundert',
      },
      {
        en: 'two hundred',
        de: 'Zweihundert',
      },
      {
        en: 'thousand',
        de: 'Tausend',
      },
      {
        en: 'Two thousand',
        de: 'Zweitausend',
      },
      {
        en: 'million',
        de: 'Million',
      },
      {
        en: 'billion',
        de: 'Milliarde',
      },
      {
        en: 'first (r)',
        de: 'erste(r)',
      },
      {
        en: 'second (r)',
        de: 'zweite(r)',
      },
      {
        en: 'third (r)',
        de: 'dritte(r)',
      },
      {
        en: 'fourth (r)',
        de: 'vierte(r)',
      },
      {
        en: 'fifth)',
        de: 'fünfte(r)',
      },
      {
        en: 'sixth (r)',
        de: 'sechste(r)',
      },
      {
        en: 'seventh)',
        de: 'siebte(r)',
      },
    ],
  },
  {
    en: 'personal pronoun',
    vocabularies: [
      {
        en: 'I',
        de: 'ich',
      },
      {
        en: 'you',
        de: 'du',
      },
      {
        en: 'he',
        de: 'er',
      },
      {
        en: 'they',
        de: 'sie',
      },
      {
        en: 'it',
        de: 'es',
      },
      {
        en: 'we',
        de: 'wir',
      },
      {
        en: 'her',
        de: 'ihr',
      },
      {
        en: 'they',
        de: 'sie',
      },
    ],
  },
  {
    en: 'Important words',
    vocabularies: [
      {
        en: 'thing',
        de: 'Ding',
      },
      {
        en: 'for sure',
        de: 'sicher',
      },
      {
        en: 'and',
        de: 'und',
      },
      {
        en: 'or',
        de: 'oder',
      },
      {
        en: 'because',
        de: 'weil',
      },
      {
        en: 'Life',
        de: 'Leben',
      },
      {
        en: 'government',
        de: 'Regierung',
      },
      {
        en: 'child',
        de: 'Kind',
      },
      {
        en: 'company',
        de: 'Firma',
      },
      {
        en: 'group',
        de: 'Gruppe',
      },
      {
        en: 'Age',
        de: 'Alter',
      },
      {
        en: 'moon',
        de: 'Mond',
      },
      {
        en: 'Sun',
        de: 'Sonne',
      },
      {
        en: 'automobile',
        de: 'Auto',
      },
      {
        en: 'book',
        de: 'Buch',
      },
      {
        en: 'world',
        de: 'Welt',
      },
      {
        en: 'family',
        de: 'Familie',
      },
      {
        en: 'friend',
        de: 'Freund',
      },
      {
        en: 'law',
        de: 'Gesetz',
      },
    ],
  },
  {
    en: 'Human / body',
    vocabularies: [
      {
        en: 'man',
        de: 'Mann',
      },
      {
        en: 'woman',
        de: 'Frau',
      },
      {
        en: 'Boy',
        de: 'Junge',
      },
      {
        en: 'girl',
        de: 'Mädchen',
      },
      {
        en: 'poor',
        de: 'Arm',
      },
      {
        en: 'hand',
        de: 'Hand',
      },
      {
        en: 'leg',
        de: 'Bein',
      },
      {
        en: 'foot',
        de: 'Fuß',
      },
      {
        en: 'eye',
        de: 'Auge',
      },
      {
        en: 'head',
        de: 'Kopf',
      },
      {
        en: 'brain',
        de: 'Gehirn',
      },
      {
        en: 'nose',
        de: 'Nase',
      },
      {
        en: 'ear',
        de: 'Ohr',
      },
      {
        en: 'hair',
        de: 'Haar',
      },
      {
        en: 'eyebrow',
        de: 'Augenbraue',
      },
      {
        en: 'lips',
        de: 'Lippen',
      },
      {
        en: 'finger',
        de: 'Finger',
      },
      {
        en: 'skeleton',
        de: 'Skelett',
      },
      {
        en: 'bone',
        de: 'Knochen',
      },
      {
        en: 'skin',
        de: 'Haut',
      },
    ],
  },
  {
    en: 'important verbs',
    vocabularies: [
      {
        en: 'be',
        de: 'sein',
      },
      {
        en: 'to get',
        de: 'bekommen',
      },
      {
        en: 'give',
        de: 'geben',
      },
      {
        en: 'Life',
        de: 'leben',
      },
      {
        en: 'do',
        de: 'machen',
      },
      {
        en: 'go',
        de: 'gehen',
      },
      {
        en: 'to use',
        de: 'benutzen',
      },
      {
        en: 'eat',
        de: 'essen',
      },
      {
        en: 'think',
        de: 'denken',
      },
      {
        en: 'come',
        de: 'kommen',
      },
      {
        en: 'to have',
        de: 'haben',
      },
      {
        en: 'to do',
        de: 'tun',
      },
      {
        en: 'say',
        de: 'sagen',
      },
      {
        en: 'knowledge',
        de: 'wissen',
      },
      {
        en: 'see',
        de: 'sehen',
      },
      {
        en: 'want',
        de: 'wollen',
      },
      {
        en: 'Find',
        de: 'finden',
      },
      {
        en: 'tell',
        de: 'erzählen',
      },
      {
        en: 'ask',
        de: 'fragen',
      },
      {
        en: 'to attempt',
        de: 'versuchen',
      },
      {
        en: 'call',
        de: 'anrufen',
      },
    ],
  },
  {
    en: 'important adjectives',
    vocabularies: [
      {
        en: 'beautiful',
        de: 'schön',
      },
      {
        en: 'ugly',
        de: 'hässlich',
      },
      {
        en: 'high',
        de: 'hoch',
      },
      {
        en: 'small',
        de: 'klein',
      },
      {
        en: 'large',
        de: 'groß',
      },
      {
        en: 'New',
        de: 'neu',
      },
      {
        en: 'long',
        de: 'lang',
      },
      {
        en: 'Great',
        de: 'großartig',
      },
      {
        en: 'old',
        de: 'alt',
      },
      {
        en: 'young',
        de: 'jung',
      },
      {
        en: 'different',
        de: 'anders',
      },
      {
        en: 'important',
        de: 'wichtig',
      },
      {
        en: 'bad',
        de: 'schlecht',
      },
      {
        en: 'funny',
        de: 'lustig',
      },
      {
        en: 'serious',
        de: 'ernst',
      },
      {
        en: 'strongly',
        de: 'stark',
      },
      {
        en: 'easy',
        de: 'einfach',
      },
      {
        en: 'heavy',
        de: 'schwer',
      },
      {
        en: 'poor',
        de: 'arm',
      },
      {
        en: 'rich',
        de: 'reich',
      },
    ],
  },
];
